import http, { url } from '../../http'

const API_URL = 'committee-quarterly-report'

/** Ítem 1.1.8 — Informe trimestral del Comité de Convivencia (para entrega a la gerencia). */
class CommitteeQuarterlyReportAPI {

  async index(companyId, page = 1) {
    return await http(`${API_URL}/company/${companyId}?page=${page}`, 'GET')
  }

  async show(id) {
    return await http(`${API_URL}/show/${id}`, 'GET')
  }

  /** Sugerencias de autollenado (reuniones del trimestre, presidente, actividades). */
  async suggest(companyId, year, quarter) {
    return await http(`${API_URL}/suggest/${companyId}?year=${year}&quarter=${quarter}`, 'GET')
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async update(id, data) {
    return await http(`${API_URL}/update/${id}`, 'PUT', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }

  /** URL directa del PDF (ruta abierta, sin firma). */
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }
}

export default new CommitteeQuarterlyReportAPI()
